export enum Theme {
  Accent100 = 'accent-100',
  Accent50 = 'accent-50',

  Primary100 = 'primary-100',
  Primary50 = 'primary-50',
}

export const Themes: Record<Theme, { title: string }> = {
  [Theme.Primary100]: {
    title: 'Primary',
  },
  [Theme.Primary50]: {
    title: 'Primary Light',
  },
  [Theme.Accent100]: {
    title: 'Accent',
  },
  [Theme.Accent50]: {
    title: 'Accent Light',
  },
};
